import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiSave, FiTrash2, FiUpload } from "react-icons/fi";
import { useDropzone } from "react-dropzone";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const LanguageCreate = () => {
  const navigate = useNavigate();

  // Dil Bilgisi
  const [code, setCode] = useState("");
  const [name, setName] = useState("");

// Kullanıcının dilini al ve çevirileri getir
const userLanguage = useUserLanguage();
const { translations: trans } = useTranslations(userLanguage);
const getText = (key, defaultValue) => trans[key] || defaultValue;

  // Çeviriler (Gerekliyse)
  const [langTranslations, setlangTranslations] = useState({});

  // Bayrak & Logo Dosyaları
  const [flagFile, setFlagFile] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  // Kaydetme Durumu
  const [saving, setSaving] = useState(false);


  // BAYRAK - DROPZONE
  const onFlagDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setFlagFile(Object.assign(file, { preview: URL.createObjectURL(file) }));
    }
  }, []);

  const {
    getRootProps: getFlagRootProps,
    getInputProps: getFlagInputProps,
    isDragActive: isFlagDragActive,
  } = useDropzone({
    onDrop: onFlagDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  const removeFlag = () => setFlagFile(null);


  // LOGO - DROPZONE
  const onLogoDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setLogoFile(Object.assign(file, { preview: URL.createObjectURL(file) }));
    }
  }, []);

  const {
    getRootProps: getLogoRootProps,
    getInputProps: getLogoInputProps,
    isDragActive: isLogoDragActive,
  } = useDropzone({
    onDrop: onLogoDrop,
    accept: "image/*",
    maxFiles: 1,
  });

  const removeLogo = () => setLogoFile(null);


  // Form Submit İşlemi
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem("admin_token");
      const languageResp = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/languages/create`,
        { code, name, langTranslations },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const languageId = languageResp.data.language_id;
      if (!languageId) throw new Error("Yeni dilin ID’si alınamadı!");

      console.log("Yeni dil ID:", languageId);

      // Bayrak Yükleme
      if (flagFile) {
        const formData = new FormData();
        formData.append("flag", flagFile);
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/languages/${languageId}/uploadFlag`,
          formData,
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
        );
      }

      // Logo Yükleme
      if (logoFile) {
        const formData = new FormData();
        formData.append("logo", logoFile);
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/languages/${languageId}/uploadLogo`,
          formData,
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
        );
      }

      toast.success("Dil Başarıyla eklendi!", {
        position: "top-right",
        autoClose: 3000,
      });
     navigate("/admin/language");
    } catch (error) {
      console.error("❌ Dil ekleme hatası:", error);
      alert("Dil eklenemedi!");
    }

    setSaving(false);
  };

  // Bileşenin Render Edilmesi

  return (
    <div className="container mt-4">
       <ToastContainer />
      <form onSubmit={handleSubmit} className="card p-4">
        <h2>{getText("ROLE_CREATE_TITLE")}</h2>

        {/* Dil Bilgisi Formu */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("TABLE_LANGUAGE_CODE_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            placeholder={getText("LANGUAGE_CODE_PLACEHOLDER")}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("TABLE_LANGUAGE_NAME_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            placeholder={getText("LANGUAGE_NAME_PLACEHOLDER")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        {/* Bayrak Yükleme Alanı */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LANGUAGE_FLAG")}</label>
          <DropzoneBox
            getRootProps={getFlagRootProps}
            getInputProps={getFlagInputProps}
            isDragActive={isFlagDragActive}
            file={flagFile}
            removeFile={removeFlag}
            placeholderText={getText("UPLOAD_FLAG")}
            // Bayrak için önizleme boyutu: 150x100
            previewStyle={{
              width: "150px",
              height: "100px",
              objectFit: "contain",
              borderRadius: "8px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        {/* Logo Yükleme Alanı */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LANGUAGE_LOGO")}</label>
          <DropzoneBox
            getRootProps={getLogoRootProps}
            getInputProps={getLogoInputProps}
            isDragActive={isLogoDragActive}
            file={logoFile}
            removeFile={removeLogo}
            placeholderText={getText("UPLOAD_LOGO")}
            // Logo için önizleme boyutu: 280x80
            previewStyle={{
              width: "280px",
              height: "80px",
              objectFit: "contain",
              borderRadius: "8px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        <div className="d-flex justify-content-center mt-4">
          <button
            className="btn btn-primary d-flex align-items-center shadow-sm px-4 py-2"
            type="submit"
            disabled={saving}
          >
            <FiSave className="me-2" />
            {saving ? getText("SAVING_BTN") : getText("SAVE_BTN")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LanguageCreate;


// DropzoneBox Bileşeni
const DropzoneBox = ({
  getRootProps,
  getInputProps,
  isDragActive,
  file,
  removeFile,
  placeholderText,
  previewStyle,
}) => {
  // Temel stil ayarları
  const baseStyle = {
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  };

  // Dosya yüklenmediğinde kullanılacak stil 
  const notLoadedStyle = {
    border: "2px dashed #007bff",
    textAlign: "center",
  };

  // Dosya yüklendiğinde kullanılacak stil
  const loadedStyle = {
    border: "2px solid #ccc",
    textAlign: "left",
  };

  // Sürükleme aktifken
  const activeStyle = isDragActive && !file ? {
    borderColor: "#28a745",
    backgroundColor: "#e6ffed",
  } : {};

  // Tüm stil ayarlarını birleştir
  const combinedStyle = {
    ...baseStyle,
    ...(file ? loadedStyle : notLoadedStyle),
    ...activeStyle,
  };

  // Varsayılan önizleme stili
  const defaultPreviewStyle = {
    width: "150px",
    height: "100px",
    objectFit: "contain",
    borderRadius: "8px",
    border: "1px solid #ddd",
  };
  const imageStyle = previewStyle || defaultPreviewStyle;
  const userLanguage = useUserLanguage();
const { translations: trans } = useTranslations(userLanguage);
const getText = (key, defaultValue) => trans[key] || defaultValue;

  return (
    <div {...getRootProps()} style={combinedStyle}>
      <input {...getInputProps()} />
      {!file ? (
        <div className="d-flex flex-column align-items-center">
          <FiUpload size={32} className="text-primary" />
          <p className="mt-2 mb-0">{placeholderText}</p>
        </div>
      ) : (
        <div className="uploaded-file d-flex flex-column align-items-start">
          <img src={file.preview} alt="Önizleme" style={imageStyle} />
          <button
            className="btn btn-sm btn-outline-danger mt-2"
            onClick={(e) => {
              e.stopPropagation();
              removeFile();
            }}
          >
           
           {getText("DELETE_FILE")}
          </button>
        </div>
      )}
    </div>
  );
};